import posthog from 'posthog-js';

const onRevoke = (): void => {
  if (typeof window !== 'undefined') {
    posthog.opt_out_capturing();
  }
};

export default onRevoke;
